import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fragment from "../fragments/PoNumberCount"

const query = gql`
  query GetProductStockCheckByPoNumber($productId: String!, $status: ProductStockStatus!) {
    productStockCheckByPoNumber(productId: $productId, status: $status) {
      ...poNumberCount
    }
  }
  ${fragment}
`

export const toString = query.loc.source.body

export const poNumberCountKey = getQueryNames(query)[0]

export default query
